import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import {
  AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_API_URL,
  AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_MUTATION,
  AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS,
} from '../constants';

export default function useDeleteFixedTrackerPaymentsMutation(): IContextMutationResult<void, Error, number> {
  const { fetchDelete } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_MUTATION],
    mutationFn: (itemId) => fetchDelete<void>(
      AFFILIATE_TRACKER_FIXED_PAYMENTS_HISTORY_DELETE_API_URL,
      {
        permission: AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS.HISTORY_CHANGES_DELETE,
        urlParams: {
          itemId,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('removed');
    },
  });
}
